import {action, computed, observable} from 'mobx';
import {api} from "../services";
import moment from "moment";
import xor from 'lodash/xor';

class TripsStore {
  @observable tripsCount = 0;
  @observable trips = [];
  @observable page = 1;
  @observable pageSize = 3;
  @observable startDate = undefined;
  @observable endDate = undefined;
  @observable search = undefined;
  @observable selectedCars = [];
  @observable sorting = 'newest'

  @observable selectedTrips = [];
  @observable mapViewSelectedTrip = null;

  @observable selectedDetailTrip = null;

  @action resetFilters = () => {
    this.clearFilters()
    this.selectedCars = [];
    this.search = undefined;
    this.sorting = 'newest';
    this.page = 1;
    return this.load();
  }

  @action clearFilters = () => {
    this.selectedDetailTrip = null;
    this.startDate = moment()
      .subtract(7, 'days')
      .startOf('day')
      .toDate();
    this.endDate = moment()
      .add(1, 'day')
      .startOf('day')
      .toDate();
  }

  @action changePage = async (page, pageSize) => {
    this.page = page;
    this.pageSize = pageSize;
    await this.load();
  }

  @action setStartDate = (date) => {
    this.startDate = date;
    this.load();
  };

  @action setEndDate = (date) => {
    this.endDate = date;
    this.load();
  };

  @action setSorting = (sorting) => {
    this.sorting = sorting;
    this.load();
  }

  @action setSearch = (searchText) => {
    this.search = searchText;
    this.load();
  }

  @action setSelectedCars = (selectedCars) => {
    this.selectedCars = selectedCars;
    this.load()
  }

  @action isTripSelected = (tripId) => {
    return this.selectedTrips.includes(tripId)
  }

  @action selectSingleTrip = (trip) => {
    this.mapViewSelectedTrip = trip
  }

  @action toggleSelection = (tripId) => {
    if(this.selectedTrips.includes(tripId)) {
      this.selectedTrips = this.selectedTrips.filter(t => t !== tripId)
    } else {
      this.selectedTrips = [...this.selectedTrips, tripId]
    }
  }

  @action selectAllTrips = () => {
    if(!this.areAllTripsSelected) {
      this.selectedTrips = this.trips.map(trip => trip.id);
    } else {
      this.selectedTrips = [];
    }
  }

  @action clearSelection = () => {
    this.selectedTrips = [];
  }

  @computed get areAllTripsSelected() {
    return xor(this.trips.map(trip => trip.id), this.selectedTrips).length === 0
  }

  @action setSelectedDetailTrip = (trip) => {
    this.selectedDetailTrip = trip;
  }

  @action clearDetailTrip = () => {
    console.log(this.selectedDetailTrip)
    this.selectedDetailTrip = null;
  }

  @action updateTrip = async (trip) => {
    this.trips = this.trips.map(t => t.id === trip.id ? trip : t);
    api('update journey', trip.id, trip)
      .then(() => {
      })
  }

  @action load = async () => {
    if(!this.startDate || !this.endDate) return;
    await api(
      `get all journeys`,
      moment(this.startDate).format('YYYY-MM-DD'),
      moment(this.endDate).format('YYYY-MM-DD'),
      this.pageSize,
      this.page,
      this.sorting,
      this.search,
      this.selectedCars
    ).then( res => {
      this.tripsCount = res.count;
      this.trips = res.rows;
      this.selectedTrips = [];
      this.mapViewSelectedTrip = res.rows[0] ? res.rows[0] : null ;
    });
  }

}
export default new TripsStore();



// WEBPACK FOOTER //
// ./src/stores/tripsStore.js